import casusBackend from '@lexian/api/casus-api';
import contactsBackend from '@lexian/api/contacts-api';
import invoicingBackend from '@lexian/api/invoicing-api';
import supportBackend from '@lexian/api/support-api';
import timetrackingBackend from '@lexian/api/time-tracking-api';
import {MasterData} from '_/state/masterdata';

export const loadMasterdata = async (): Promise<MasterData> => {
  const [
    supportMasterdata,
    contactsMasterdata,
    invoicingMasterdata,
    casusMasterdata,
    timetrackingMasterdata,
    lexianFrontendSettings,
  ] = await Promise.all([
    supportBackend.getSupportMasterData({
      parameters: {},
    }),
    contactsBackend.getContactMasterData({
      parameters: {},
    }),
    invoicingBackend.getInvoicingMasterData({
      parameters: {},
    }),
    casusBackend.getCasusMasterData({
      parameters: {},
    }),
    timetrackingBackend.getTimetrackingMasterData({
      parameters: {},
    }),
    supportBackend.getLexianFrontendSettings({
      parameters: {},
    }),
  ]);

  if (
    supportMasterdata.hasError ||
    contactsMasterdata.hasError ||
    invoicingMasterdata.hasError ||
    casusMasterdata.hasError ||
    timetrackingMasterdata.hasError ||
    lexianFrontendSettings.hasError
  ) {
    throw new Error('Error during loading of masterdata');
  }

  return {
    ...supportMasterdata.body!.body,
    ...contactsMasterdata.body!.body,
    ...invoicingMasterdata.body!.body,
    ...casusMasterdata.body!.body,
    ...timetrackingMasterdata.body!.body,
    ...lexianFrontendSettings.body!.body,
  };
};
